import { useContext, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { AppLink, AppText, Button, Circle, CustomContainer, FlexColumn, FlexRow, Form, FormGroup, GridContainer } from "src/style"
import utility from "src/utils/utility"
import {ReactComponent as Logo} from 'src/assets/img/crendly-logo-blue.svg'
import { IoChevronBackOutline } from 'react-icons/io5'
import ApiContext from 'src/provider/API/call-service'
import VisibilityContext from 'src/provider/state-manager/visibilityProvider'


const PasswordReset: React.FC = () => {
    const navigate = useNavigate()
    const {API} = useContext(ApiContext)
    const {notifier} = useContext(VisibilityContext)
    const [input, setInput] = useState({newPassword: '', confirmPassword: ''})

    const handleInput = (e: React.ChangeEvent<HTMLInputElement>) => setInput({...input, [e.target.name]: e.target.value})

    async function handlePasswordReset(e: React.FormEvent<HTMLButtonElement | HTMLFormElement>) {
        e.preventDefault()

        if (input.newPassword != input.confirmPassword) return notifier.show('Password confirmation does not match', 'Validation Response')
        const response = await API.resetPassword(input)
        if (response) navigate('/')
    }

    return (
        <FlexColumn 
            height='100' hUnit='%' width='100' 
            sizeUnit='%' justifyContent='space-between'
            bottomPadding='1.5' leftPadding='1' rightPadding='1'
        >
            <GridContainer 
                width='90' sizeUnit='%' height='7'
                className="forgetpassword-header"
            >
                <FlexRow 
                    justifyContent="space-between"
                >
                    <Logo />
                    <AppLink decoration="none" color='#101225' textSize="1.2">User type selected here</AppLink>
                </FlexRow>
            </GridContainer>
            <FlexRow alignItems='flex-start' width='auto' sizeUnit=''>
                <GridContainer 
                    height='3' width='3.2' borderColor=' #E4ECF7' 
                    radius='0.4' rightMargin='4'
                    onClick={() => navigate(-1)}
                >
                    <IoChevronBackOutline className='back-icon' />
                </GridContainer>
                <CustomContainer 
                    width='52' minHeight='60' bgColor='#ffffff'
                    borderColor='#E2E8F0' radius='0.8' topPadding='3'
                    bottomPadding='3' rightPadding='4.5' leftPadding='4.5'
                >
                    <AppText color='#27272E' textSize='2.8' fontWeight='600' align='center' bottomMargin='1'>Set new password</AppText>
                    <AppText color=' #27272E' textSize='1.6' align='center' width='90' sizeUnit='%' >
                        Your password must be different from the previously used password
                    </AppText>
                    <Form topMargin='6' onSubmit={handlePasswordReset}>
                        <FormGroup>
                            <label>New Password</label>
                            <input 
                                type='password'
                                placeholder='Type your new password'
                                name='newPassword'
                                onChange={handleInput}
                                required
                            />
                        </FormGroup>
                        <FormGroup>
                            <label>Confirm Password</label>
                            <input 
                                type='password'
                                placeholder='Retype your new password'
                                name='confirmPassword'
                                onChange={handleInput}
                                required
                            />
                            <AppText color='#718096' textSize='1.1' topMargin='0.7'>Must be 8 characters at least</AppText>
                        </FormGroup>
                        <Button
                            width='100' sizeUnit='%' borderColor='#4C6FFF' height='4.5'
                            hoverBgColor='#ffffff' hoverColor='#4C6FFF' bottomMargin='1.5'
                        >
                            Reset password
                        </Button>

                       <GridContainer bottomMargin='2'>
                            <Button
                                width='14' height='4' bgColor='#FAFAFA'
                                hoverColor='#4C6FFF' radius='0.6' color='#425466'
                                onClick={() => navigate('/')}
                            >
                                <IoChevronBackOutline style={{marginLeft: '1rem'}} /> 
                                Back to login
                            </Button>
                       </GridContainer>
                    </Form>
                </CustomContainer>
            </FlexRow>
            <GridContainer 
                width='90' sizeUnit='%' height='5'
                className="forgetpassword-footer"
            >
                <FlexRow 
                    justifyContent="space-between"
                >
                    <AppLink 
                        decoration='none' textSize='1.2'
                    >
                        Crendly support panel 2022
                    </AppLink>
                </FlexRow>
            </GridContainer>
        </FlexColumn>
    )
}

export default utility.routeData('forgetpassword/password-reset', 'Password Reset', <PasswordReset/>)